(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerWrapper = this.querySelector('.header-wrapper') || this;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isTransparent = this.headerWrapper && this.headerWrapper.classList.contains('header-wrapper--transparent');

      // Add transparent class to parent section for positioning
      if (this.isTransparent && this.header) {
        this.header.classList.add('section-header--transparent');
      }

      this.setHeaderHeight();

      // The nav reflows after the initial measurement (web font swap-in,
      // window resize changing menu wrapping), and a stale --header-height
      // leaves a gap between the header and the fixed bar pinned below it.
      // Re-measure whenever the header or the band actually changes size.
      this.setHeaderHeightBound = this.setHeaderHeight.bind(this);
      const blackBand = document.querySelector('.section-black-band');
      if ('ResizeObserver' in window) {
        this.heightObserver = new ResizeObserver(this.setHeaderHeightBound);
        this.heightObserver.observe(this.header);
        if (blackBand) this.heightObserver.observe(blackBand);
      } else {
        window.addEventListener('resize', this.setHeaderHeightBound);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.setHeaderHeightBound);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Ensure state is correct on initial load (e.g. reload mid-scroll)
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      // Calculate total header group height (header + black-band if present)
      const blackBand = document.querySelector('.section-black-band');
      const totalHeight = this.header.offsetHeight + (blackBand ? blackBand.offsetHeight : 0);
      document.documentElement.style.setProperty('--header-group-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.heightObserver) this.heightObserver.disconnect();
      window.removeEventListener('resize', this.setHeaderHeightBound);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Handle transparent header scroll state - add background when scrolled
      if (this.isTransparent && this.headerWrapper) {
        // Show solid background immediately when not at the very top (scrollTop > 0)
        if (scrollTop > 0) {
          this.headerWrapper.classList.add('is-scrolled');
          this.header.classList.add('header-scrolled');
        } else {
          this.headerWrapper.classList.remove('is-scrolled');
          this.header.classList.remove('header-scrolled');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
